import { SET_PAST_VISIT_ERROR } from './PastVisitConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setError = (error, visitId) => ({
  type: SET_PAST_VISIT_ERROR,
  payload: { error: error || '', visitId },
})
